import React from 'react';
import { APP_NAME } from '../../config/constants';

const Footer = () => (
  <div className="nk-footer">
    <div className="nk-footer-wrap">
      <div className="nk-footer-copyright">
        &copy; {new Date().getFullYear()} {APP_NAME}. Indgiants Association of Educators &amp; Professional Trainers.
      </div>
      <div className="nk-footer-links">
        <ul className="nav nav-sm">
          <li className="nav-item">
            <a className="nav-link" href="#terms" onClick={(e) => e.preventDefault()}>Terms</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#privacy" onClick={(e) => e.preventDefault()}>Privacy</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#help" onClick={(e) => e.preventDefault()}>Help</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default Footer;
